import { useRouteError } from 'react-router';

import { isSelfServiceError } from '../../helpers/Errors';
import Language from '../../helpers/Language';
import { sendAnalyticsEvent } from '../../services/Analytics';
import { SupportedErrorTypes } from '../../services/ErrorService';
import { getMaintenance } from '../../services/MaintenanceService';
import { MaintenanceComponent } from '../Maintenance/MaintenanceComponent';
import { AppView } from '../TicketOutlet/AppView';
import { ErrorComponent } from './ErrorComponent';

export function SelfServiceErrorBoundary({ withAppView = true }: { withAppView?: boolean }) {
  const routerError = useRouteError();

  const error = routerError as Error;

  if (isSelfServiceError(error)) {
    sendAnalyticsEvent('error', 'error-boundary', { error: error.reason }, false, 'posthog');
    const maintenance = error.stylesheet ? getMaintenance(error.stylesheet) : undefined;

    const settings = error.stylesheet
      ? error.stylesheet[Language.getLanguage()]?.settings
      : undefined;

    const errorElement = error.reason === SupportedErrorTypes.maintenance && maintenance ?
      <MaintenanceComponent maintenance={maintenance} /> :
      <ErrorComponent errorType={error.reason} settings={settings} />;

    if (!withAppView || !error.stylesheet) {
      return errorElement;
    }

    return (
      <AppView
        brandStylesheet={error.stylesheet}
        errorMode
        globalStylesheet={error.stylesheet}
        ticket={error.ticket}>
        {errorElement}
      </AppView>
    );
  }

  sendAnalyticsEvent('error', 'error-boundary', { error: SupportedErrorTypes.unexpectedError }, false, 'posthog');

  return <ErrorComponent errorType={SupportedErrorTypes.unexpectedError} />;
}
